import { render, staticRenderFns } from "./RootTransferDialog.vue?vue&type=template&id=13a4ca1e&scoped=true&"
import script from "./RootTransferDialog.vue?vue&type=script&lang=js&"
export * from "./RootTransferDialog.vue?vue&type=script&lang=js&"
import style0 from "./RootTransferDialog.vue?vue&type=style&index=0&id=13a4ca1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4ca1e",
  null
  
)

export default component.exports